import { MosState } from "chat/imports/state";

export const getMosChatV2Items = (state: MosState) => state.items;

export const getMosChatV2LineupId = (state: MosState) => state.lineupId;

export const getMosChatV2Loading = (state: MosState) => state.loading;

export const getMosChatV2Error = (state: MosState) => state.error;
